import { Pipe, PipeTransform } from '@angular/core';
import { BaseObject } from '@adgate/common/types/base-object.type';

@Pipe({
  name: 'objectdesc',
  standalone: true
})
export class ObjectDescPipe implements PipeTransform 
{
  transform(value: BaseObject, ..._args: unknown[]): string {
    if ( value != null ) {
        return value.description!
    } else {
        return "";
    }
  }
}
